import { Game, GameOverviewState } from "./games-overview.type";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: GameOverviewState = {
  games: {
    allIds: [],
    byId: {},
    allCategories: [],
    categories: {},
  },
};

export const gameOverviewSlice = createSlice({
  name: "game-overview",
  initialState: initialState,
  reducers: {
    setGames: (state, action: PayloadAction<Record<string, Game>>) => {
      state.games.byId = action.payload;
      const allIds = Object.keys(action.payload);
      state.games.allIds = allIds;
      const categories = allIds.reduce((acc, next) => {
        const category = action.payload[next].category;
        if (acc[category]) {
          acc[category].push(next);
        } else {
          acc[category] = [next];
        }
        return acc;
      }, {} as Record<string, string[]>);
      state.games.categories = categories;
      state.games.allCategories = Object.keys(categories).sort();
    },

    resetGames: () => {
      return initialState;
    },
  },
});

export const { setGames, resetGames } = gameOverviewSlice.actions;

export default gameOverviewSlice.reducer;
